import React from 'react';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  InputGridGroup,
  Text,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import {
  CHARACTER_LIMIT_LIST,
  CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
  GET_BUSINESS_TYPE,
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  PROPOSER_DROPDOWN_DETAIL,
} from 'quanta-flows/modules/proposal/health';
import { Loading } from 'quanta-flows/modules/layout';
import { updateBuyHealthPolicy } from 'quanta-flows/modules/proposal/health/state';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export default function InsuredMembers({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
  ...props
}) {
  productCode="2880";
  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 3 });

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS);
  const { loading, data: dropDownDetails } = useQuery(
    CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
    {
      fetchPolicy: 'cache-first',
    },
  );
  const {
    loading: loadingProposerDetail,
    error: errorProposerDetail,
    data: dataProposerDetail,
  } = useQuery(PROPOSER_DROPDOWN_DETAIL, {
    variables: {
      productCode,
    },
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingBusinessType,
    error: errorBusinessType,
    data: dataBusinessType,
  } = useQuery(GET_BUSINESS_TYPE);

  const {
    loading: loadingNameLimit,
    error: errorNameLimit,
    data: dataNameLimit,
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first'
  });

  if (
    loadingBuyPolicy ||
    loading ||
    loadingProposerDetail ||
    loadingBusinessType ||
    loadingNameLimit
  ) {
    return (
      <div className="min-h-screen">
        <Loading customMessage={'Fetching members'} />
      </div>
    );
  }
  if (errorBuyPolicy || errorProposerDetail || errorBusinessType || errorNameLimit) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            errorBuyPolicy || errorProposerDetail || errorBusinessType || errorNameLimit
          }
        />
      </div>
    );
  }
  const { buyHealthPolicy } = dataBuyPolicy;
  const { insuredDetails } = buyHealthPolicy;
  const {
    salutationList,
    genderList,
    maritalStatusList,
    occupationList,
  } = dropDownDetails;
  const {
    PRD_PreExistDiseaseWaitPeriod,
    PRD_OccupationList,
    PRD_CumulativeBonus,
  } = dataProposerDetail;
  const { businessTypeList } = dataBusinessType;
  const { characterLimitList } = dataNameLimit;

  const getInitObject = () => {
    let initObj = {};
    insuredDetails.forEach((insured) => {
      initObj[insured.relationship] = {
        title: insured.title
          ? insured.title
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.title
          : '',
        gender: insured.gender
          ? insured.gender
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.gender
            ? buyHealthPolicy.proposerDetails.gender
            : buyHealthPolicy.quoteData.members.find(
                (m) => m.relationship === insured.relationship,
              ).gender
          : buyHealthPolicy.quoteData.members.find(
              (m) => m.relationship === insured.relationship,
            ).gender,
        dob: insured.dob
          ? insured.dob
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.proposerDOB
            ? buyHealthPolicy.proposerDetails.proposerDOB
            : buyHealthPolicy.quoteData.members.find(
                (m) => m.relationship === insured.relationship,
              ).dob
          : buyHealthPolicy.quoteData.members.find(
              (m) => m.relationship === insured.relationship,
            ).dob,
        firstName: insured.firstName
          ? insured.firstName
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.firstName
          : '',
        middleName: insured.middleName
          ? insured.middleName
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.middleName
          : '',
        lastName: insured.lastName
          ? insured.lastName
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.lastName
          : '',
        maritalStatus: insured.maritalStatus
          ? insured.maritalStatus
          : insured.relationship.toLowerCase() === 'self'
          ? buyHealthPolicy.proposerDetails.maritalStatus
          : '',
        height: insured.height ? insured.height : '',
        weight: insured.weight ? insured.weight : '',
        // occupation: insured.occupation ? insured.occupation : '',
        occupation: insured.occupation
        ? insured.occupation.value
          : insured.relationship.toLowerCase() === 'self'
        //?buyHealthPolicy?.proposerDetails?.occupation
        ? occupationList?.find((e)=>
        e.code == buyHealthPolicy?.proposerDetails?.occupation)?.value
          : '',
        otherOccupation: insured.otherOccupation
          ? insured.otherOccupation
         : insured.relationship.toLowerCase() === 'self'
         ?buyHealthPolicy?.proposerDetails?.otherOccupation
        //  ? occupationList?.find((e)=>
        //  e.code == buyHealthPolicy?.proposerDetails?.otherOccupation)
          : '',
        pedWaitingPeriod: insured.pedWaitingPeriod
          ? insured.pedWaitingPeriod
          : '',
        isPortabilityRequired: insured.isPortabilityRequired
          ? insured.isPortabilityRequired
          : false,
        cbBonusPct: insured.cbBonusPct ? insured.cbBonusPct : '',
        ppcTestLevel: insured.ppcTestLevel
          ? insured.ppcTestLevel
          : '',
        memberStatus: insured.memberStatus
          ? insured.memberStatus
          : '',
        memberID: insured.memberID ? insured.memberID : '',
      };
    });
    return initObj;
  };

  const initialValues = getInitObject();
//console.log('buyHealthPolicy',buyHealthPolicy)
  const validate = (values) => {
    let errors = {};
    let Pcount = 0;
    let Truecount =0;
    insuredDetails.forEach((insured) => {
      //console.log('216_inside for each',insured)
      errors[`${insured.relationship}`] = {};
      if (!values[`${insured.relationship}`].title) {
        errors[`${insured.relationship}`].title = '* Required';
      }
      if (
        values[`${insured.relationship}`].title?.toLowerCase() !==
        getDomainData(
          salutationList,
          values[`${insured.relationship}`].title,
          'code',
          'code',
        )?.toLowerCase()
      ) {
        errors[`${insured.relationship}`].title =
          '* Enter valid title';
      } else if (
        getDomainData(
          salutationList,
          values[`${insured.relationship}`].title,
          'code',
          'gender',
        )?.toLowerCase() &&
        values[`${insured.relationship}`]?.gender?.toLowerCase() !==
          getDomainData(
            salutationList,
            values[`${insured.relationship}`].title,
            'code',
            'gender',
          )?.toLowerCase() &&
        (getDomainData(
          genderList,
          values[`${insured.relationship}`].gender,
          'code',
          'value',
        )?.toLowerCase() === 'male' ||
          getDomainData(
            genderList,
            values[`${insured.relationship}`].gender,
            'code',
            'value',
          )?.toLowerCase() === 'female')
      ) {
        errors[`${insured.relationship}`].title =
          '* Title mismatch with gender';
      }
      if (!values[`${insured.relationship}`].height) {
        errors[`${insured.relationship}`].height = '* Required';
      }
      if (!values[`${insured.relationship}`].weight) {
        errors[`${insured.relationship}`].weight = '* Required';
      }
      if (!values[`${insured.relationship}`].gender) {
        errors[`${insured.relationship}`].gender = '* Required';
      }
      if (!values[`${insured.relationship}`].dob) {
        errors[`${insured.relationship}`].dob = '* Required';
      }
      if (values[`${insured.relationship}`].dob) {
        if (
          moment(
            values[`${insured.relationship}`].dob,
            'DD/MM/YYYY',
          ).isAfter()
        ) {
          errors[`${insured.relationship}`].dob =
            '* Date of Birth cannot be a future date';
        }
      }
      const firstNameValue = characterLimitList?.find(
        (characterLimit) =>
          characterLimit.code.toLowerCase() === 'first name',
      );
      const middleNameValue = characterLimitList?.find(
        (characterLimit) =>
          characterLimit.code.toLowerCase() === 'middle name',
      );
      const lastNameValue = characterLimitList?.find(
        (characterLimit) =>
          characterLimit.code.toLowerCase() === 'last name',
      );
      if (!values[`${insured.relationship}`].firstName) {
        errors[`${insured.relationship}`].firstName = '* Required';
      } else if (
        values[`${insured.relationship}`].firstName &&
        values[`${insured.relationship}`].firstName.match(/\d/)
      ) {
        errors[`${insured.relationship}`].firstName =
          '* First name cannot be alphanumeric';
      } else if (
        values[`${insured.relationship}`].firstName.length >
        firstNameValue.value
      ) {
        errors[
          `${insured.relationship}`
        ].firstName = `* First Name cannot be greater than ${firstNameValue.value} characters`;
      }   
      if (
        values[`${insured.relationship}`].middleName &&
        values[`${insured.relationship}`].middleName.match(/\d/)
      ) {
        errors[`${insured.relationship}`].middleName =
          '* Middle name cannot be alphanumeric';
      } else if (
        values[`${insured.relationship}`].middleName.length >
        middleNameValue.value
      ) {
        errors[
          `${insured.relationship}`
        ].middleName = `* Middle Name cannot be greater than ${middleNameValue.value} characters`;
      } 
      if (!values[`${insured.relationship}`].lastName) {
        errors[`${insured.relationship}`].lastName = '* Required';
      } else if (
        values[`${insured.relationship}`].lastName &&
        values[`${insured.relationship}`].lastName.match(/\d/)
      ) {
        errors[`${insured.relationship}`].lastName =
          '* Last name cannot be alphanumeric';
      } else if (
        values[`${insured.relationship}`].lastName.length >
        lastNameValue.value
      ) {
        errors[
          `${insured.relationship}`
        ].lastName = `* Last Name cannot be greater than ${lastNameValue.value} characters`;
      }
      if (!values[`${insured.relationship}`].maritalStatus) {
        errors[`${insured.relationship}`].maritalStatus =
          '* Required';
      }
      if (!values[`${insured.relationship}`].occupation) {
        errors[`${insured.relationship}`].occupation = '* Required';
      }
      if (
        values[`${insured.relationship}`].occupation &&
        getDomainData(
          PRD_OccupationList,
          values[`${insured.relationship}`].occupation,
          'code',
          'value',
        )?.toLowerCase() === 'others' &&
        !values[`${insured.relationship}`].otherOccupation
      ) {
        errors[`${insured.relationship}`].otherOccupation =
          '* Required';
      }
    //  console.log('portability',values[`${insured.relationship}`].isPortabilityRequired)
      if(values[`${insured.relationship}`].isPortabilityRequired.toString() === 'true' )
      {
      Truecount =Truecount + 1;
      }
      Pcount = Pcount + 1;
     // console.log('person',Pcount)
     // console.log('Truecount',Truecount)
    });
    if(buyHealthPolicy.quotationType.toString() === 'Roll Over' )
    {
      if (Pcount > 0)
      { 
    //  console.log('insidePcount',Pcount)
        if (Truecount <= 0)
        {
          //console.log('insideTruecount',Truecount)
          insuredDetails.forEach((insured) => {
          errors[`${insured.relationship}`].isPortabilityRequired =
          '* For Roll Over atleast 1 Portability is Required';
          });
        }
      }
    } 
    let error_count = 0;
    insuredDetails.forEach((insured) => {
      error_count += Object.keys(errors[`${insured.relationship}`])
        .length;
    });
    if (error_count === 0) {
      errors = {};
    }
    return errors;
  };

  const InsuredMemberForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();

    const data = insuredDetails
      ? insuredDetails.map((m) => {
          return {
            title: (
              <>
                <Text severity="info" type="large">
                  {m.relationship}{' '}
                </Text>
                <Text severity="error" type="title">
                  *
                </Text>
              </>
            ),
            size: 'medium',
            grid_data: [
              {
                type: 'select',
                label: (
                  <div>
                    Title <Text severity="error">*</Text>
                  </div>
                ),
                searchable: true,
                data:
                  salutationList && salutationList?.length > 0
                    ? salutationList?.filter(
                        (salutation) =>
                          salutation?.gender?.toLowerCase() ===
                          values[
                            `${m.relationship}`
                          ].gender?.toLowerCase(),
                      )?.length === 0
                      ? salutationList?.map((salutation) => {
                          return {
                            label: salutation?.value
                              ? salutation?.value
                              : '',
                            value: salutation?.code
                              ? salutation?.code
                              : '',
                          };
                        })
                      : salutationList
                          ?.filter(
                            (salutation) =>
                              salutation?.gender?.toLowerCase() ===
                                values[
                                  `${m.relationship}`
                                ].gender?.toLowerCase() ||
                              !salutation?.gender,
                          )
                          ?.map((salutation) => {
                            return {
                              label: salutation?.value
                                ? salutation?.value
                                : '',
                              value: salutation?.code
                                ? salutation?.code
                                : '',
                            };
                          })
                    : [],
                name: `${m.relationship}.title`,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
                onDataChange: (val, setFieldValue) => {
                  if (
                    getDomainData(
                      salutationList,
                      val,
                      'value',
                      'code',
                    )
                  ) {
                    setFieldValue(
                      `${m.relationship}.title`,
                      getDomainData(
                        salutationList,
                        val,
                        'value',
                        'code',
                      ),
                    );
                  }
                },
              },
              {
                type: 'select',
                label: (
                  <div>
                    Gender <Text severity="error">*</Text>
                  </div>
                ),
                data: genderList
                  ? [
                      ...genderList.map((gender) => {
                        return {
                          label: gender.value ? gender.value : '',
                          value: gender.code ? gender.code : '',
                        };
                      }),
                    ]
                  : [],
                name: `${m.relationship}.gender`,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
              },
              {
                type: 'date',
                label: (
                  <div className="space-x-2">
                    <span>
                      Date of Birth <Text severity="error">*</Text>
                    </span>
                    {buyHealthPolicy?.quoteData?.members?.find(
                      (member) =>
                        member.relationship === m.relationship,
                    )?.dob !== values[`${m.relationship}`].dob && (
                      <Text severity="warning">
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          title="DOB changes might affect proposal premium."
                          className="cursor-pointer"
                        />
                      </Text>
                    )}
                  </div>
                ),
                name: `${m.relationship}.dob`,
              //  disabled: buyHealthPolicy?.proposalNumber.length > 0,
              disabled: buyHealthPolicy?.proposalNumber.length > 0 ||
              ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0  && m.relationship.toLowerCase() === 'self' && buyHealthPolicy?.proposerDetails?.customerType ==='Individual'),
              },
              {
                type: 'text',
                label: (
                  <div>
                    First Name <Text severity="error">*</Text>
                  </div>
                ),
             //   disabled: buyHealthPolicy?.proposalNumber.length > 0,
                disabled: buyHealthPolicy?.proposalNumber.length > 0 ||
                ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0  && m.relationship.toLowerCase() === 'self' && buyHealthPolicy?.proposerDetails?.customerType ==='Individual'),
                name: `${m.relationship}.firstName`,
              },
              {
                type: 'text',
                label: (
                  <div>
                    Middle Name <Text></Text>
                  </div>
                ),
                name: `${m.relationship}.middleName`,
              //  disabled: buyHealthPolicy?.proposalNumber.length > 0,
              disabled: buyHealthPolicy?.proposalNumber.length > 0 || 
              ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0  && m.relationship.toLowerCase() === 'self' && buyHealthPolicy?.proposerDetails?.customerType ==='Individual'),
              },
              {
                type: 'text',
                label: (
                  <div>
                    Last Name <Text severity="error">*</Text>
                  </div>
                ),
                name: `${m.relationship}.lastName`,
                //disabled: buyHealthPolicy?.proposalNumber.length > 0,
                disabled: buyHealthPolicy?.proposalNumber.length > 0 || 
                ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0  && m.relationship.toLowerCase() === 'self' && buyHealthPolicy?.proposerDetails?.customerType ==='Individual'),
              },
              {
                type: 'select',
                label: (
                  <div>
                    Marital Status <Text severity="error">*</Text>
                  </div>
                ),
                data: maritalStatusList
                  ? [
                      ...maritalStatusList.map((maritalStatus) => {
                        return {
                          label: maritalStatus.value
                            ? maritalStatus.value
                            : '',
                          value: maritalStatus.code
                            ? maritalStatus.code
                            : '',
                        };
                      }),
                    ]
                  : [],
                name: `${m.relationship}.maritalStatus`,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
              },
              {
                type: 'number',
                label: (
                  <div>
                    Height <Text severity="error">*</Text>
                  </div>
                ),
                iconPost: 'cms',
                name: `${m.relationship}.height`,
                className:
                  buyHealthPolicy?.proposalNumber.length > 0
                    ? `border-neutral-dark`
                    : ``,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
              },
              {
                type: 'number',
                label: (
                  <div>
                    Weight <Text severity="error">*</Text>
                  </div>
                ),
                iconPost: 'Kgs',
                name: `${m.relationship}.weight`,
                className:
                  buyHealthPolicy?.proposalNumber.length > 0
                    ? `border-neutral-dark`
                    : ``,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
              },
              {
                type: 'select',
                label: (
                  <div>
                    Occupation <Text severity="error">*</Text>
                  </div>
                ),
                data: PRD_OccupationList
                  ? [
                      ...PRD_OccupationList.map((occupation) => {
                        return {
                          label: occupation.value
                            ? occupation.value
                            : '',
                          value: occupation.code
                            ? occupation.code
                            : '',
                        };
                      }),
                    ]
                  : [],
                name: `${m.relationship}.occupation`,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
                onDataChange: (val, setFieldValue) => {
                  setFieldValue(
                    `${m.relationship}.otherOccupation`,
                    '',
                  );
                },
              },
              {
                type: 'text',
                maxLength: 100,
                disabled:
                  values[`${m.relationship}`].occupation !==
                    getDomainData(
                      PRD_OccupationList,
                      'Others',
                      'value',
                      'code',
                    ) || buyHealthPolicy?.proposalNumber.length > 0,
                label: (
                  <div>
                    If Other Occupation, Please specify (max 100
                    characters)
                    <Text severity="error">
                      {getDomainData(
                        PRD_OccupationList,
                        values[`${m.relationship}`].occupation,
                        'code',
                        'value',
                      )?.toLowerCase() === 'others'
                        ? ' *'
                        : null}
                    </Text>
                  </div>
                ),
                name: `${m.relationship}.otherOccupation`,
              },
               productCode.toString() !== '2880' ?
              {
                type: 'select',
                label: (
                  <div>
                    Pre-Existing Disease waiting period<Text></Text>
                  </div>
                ),
                data: PRD_PreExistDiseaseWaitPeriod
                  ? [
                      ...PRD_PreExistDiseaseWaitPeriod.map(
                        (pedWaitingPeriod) => {
                          return {
                            label: pedWaitingPeriod.value
                              ? pedWaitingPeriod.value
                              : '',
                            value: pedWaitingPeriod.code
                              ? pedWaitingPeriod.code
                              : '',
                          };
                        },
                      ),
                    ]
                  : [],
                name: `${m.relationship}.pedWaitingPeriod`,
                disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( productCode.toString() === '2885'|| productCode.toString() === '2880' ),
             
              }:'',
              getDomainData(
                businessTypeList,
                buyHealthPolicy?.quotationType,
                'code',
                'value',
              )?.toLowerCase() === 'roll ove'
                ? {
                    type: 'select',
                    label: (
                      <div>
                        Cumulative Bonus (in %) <Text></Text>
                      </div>
                    ),
                    data: PRD_CumulativeBonus
                      ? [
                          ...PRD_CumulativeBonus.map(
                            (cumulativeBonus) => {
                              return {
                                label: cumulativeBonus.value
                                  ? cumulativeBonus.value?.toString()
                                  : '',
                                value: cumulativeBonus.code
                                  ? cumulativeBonus.code?.toString()
                                  : '',
                              };
                            },
                          ),
                        ]
                      : [],
                    name: `${m.relationship}.cbBonusPct`,
                  }
                : null,
              m?.ppcTestLevel
                ? {
                    type: 'render',
                    component: () => (
                      <div className="flex flex-col">
                        <Text type="label" severity="info">
                          PPC Test Level
                        </Text>
                        <Text>
                          {m?.ppcTestLevel ? (
                            m?.ppcTestLevel
                          ) : (
                            <Text className="opacity-40">
                              Not Captured
                            </Text>
                          )}
                        </Text>
                      </div>
                    ),
                  }
                : null,
              m?.memberStatus
                ? {
                    type: 'render',
                    component: () => (
                      <div className="flex flex-col">
                        <Text type="label" severity="info">
                          Member Status
                        </Text>
                        <Text>
                          {m?.memberStatus ? (
                            m?.memberStatus
                          ) : (
                            <>
                              <Text className="opacity-40">
                                Not Captured
                              </Text>
                              <br />
                            </>
                          )}
                        </Text>
                      </div>
                    ),
                  }
                : null,
              {
                type: 'checkbox',
                name: `${m.relationship}.isPortabilityRequired`,
                label: (
                  <Text>
                    Do you want to port this member from another
                    insurer?
                  </Text>
                ),
                colSpan: repeat,
              },
            ].filter((d) => d),
          };
        })
      : [];

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };

    return (
      <>
        <QuantaForm className="space-y-4 mt-3">
          <InputGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
      </>
    );
  };
  const submitInsuredArr = (values) => {
    let submitArr = [];
    Object.keys(values).forEach((m) => {
      submitArr.push({
        relationship: m,
        ...values[m],
        cbBonusPct: parseFloat(values[m]?.cbBonusPct),
      });
    });
    return { insuredDetails: submitArr };
  };

  const onSubmit = (values) => {
    if (Object.values(validate(values)).length === 0) {
      setParentAlerts([]);
      setProceedToNextStep([
        proceedToNextStep[0],
        true,
        ...proceedToNextStep.slice(2),
      ]);
      updateBuyHealthPolicy(submitInsuredArr(values));
      return true;
    }
    return false;
  };

  return (
    <div>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <InsuredMemberForm {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
